import { render, staticRenderFns } from "./Operadora.vue?vue&type=template&id=f96a1eba&"
import script from "./Operadora.vue?vue&type=script&lang=js&"
export * from "./Operadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports